(function () {
  'use strict';

  if (window.DkhounBackgroundVideo) {
    window.DkhounBackgroundVideo.init(document);
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  function syncPlayback(container) {
    const video = container.querySelector('[data-bgvideo-insert] video');
    if (!video) return;

    const shouldPlay = container.dataset.dkBgVisible === 'true' && !document.hidden && !reducedMotion.matches;
    if (!shouldPlay) {
      video.pause();
      return;
    }

    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  }

  function bootThemePlayer(container, attempt) {
    if (window.T4SThemeSP && typeof window.T4SThemeSP.BgVideo === 'function') {
      window.T4SThemeSP.BgVideo();
      window.setTimeout(() => syncPlayback(container), 0);
      return;
    }

    if (attempt < 50) {
      window.setTimeout(() => bootThemePlayer(container, attempt + 1), 100);
    }
  }

  function activate(container) {
    if (container.dataset.dkBgActivated === 'true' || reducedMotion.matches) return;
    container.dataset.dkBgActivated = 'true';
    container.setAttribute('data-video-background', '');

    const mutations = new MutationObserver(() => syncPlayback(container));
    const insertionPoint = container.querySelector('[data-bgvideo-insert]');
    if (insertionPoint) mutations.observe(insertionPoint, { childList: true, subtree: true });

    bootThemePlayer(container, 0);
  }

  function observe(container) {
    if (container.dataset.dkBgReady === 'true') return;
    container.dataset.dkBgReady = 'true';
    observer.observe(container);
  }

  function init(scope) {
    scope.querySelectorAll('[data-dk-bg-video]').forEach(observe);
  }

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const container = entry.target;
      const visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
      container.dataset.dkBgVisible = visible ? 'true' : 'false';
      if (visible) activate(container);
      syncPlayback(container);
    });
  }, { rootMargin: '120px 0px', threshold: [0, 0.1] });

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('[data-dk-bg-video]').forEach(syncPlayback);
  });

  const handleReducedMotion = () => {
    document.querySelectorAll('[data-dk-bg-video]').forEach(syncPlayback);
  };
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', handleReducedMotion);
  else reducedMotion.addListener(handleReducedMotion);

  window.DkhounBackgroundVideo = { init };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
}());
